import type { ReactNode } from "react"
import "./plan-card.css"

export interface PlanLine { text: string; lead?: string; soon?: boolean; quiet?: boolean }

/** "10 Order drafts / day" -> { lead: "10", text: "Order drafts / day" }; other lines pass through. */
export function planLine(s: string): PlanLine {
  const m = /^(\d+) (.+)$/.exec(s)
  return m ? { lead: m[1], text: m[2] } : { text: s }
}

/** The tier card of the pricing page, drawn once: eyebrow, plan name, price, benefit lines, an action
 * and a note. `tone` is the pricing page's modifier ("featured" is Nira Pro's cobalt border). */
export function PlanCard({ eyebrow, name, price, lines, action, note, tone, headingId, as: Tag = "div" }: {
  eyebrow: string
  name: string
  price: ReactNode
  lines: PlanLine[]
  action?: ReactNode
  note?: ReactNode
  tone?: "featured" | "paid"
  headingId?: string
  as?: "div" | "section"
}) {
  return (
    <Tag className={`nst-tier${tone ? ` ${tone}` : ""}`} aria-labelledby={headingId}>
      <div className="nst-tier-h"><p className="nst-k">{eyebrow}</p><h2 id={headingId}>{name}</h2></div>
      {price}
      <ul className="nst-tier-lines">
        {lines.map((l) => (
          <li key={l.text} className={l.quiet ? "quiet" : ""}>
            {l.lead ? <span className="nst-lead">{l.lead}</span> : null}
            <span>{l.text}</span>
            {l.soon ? <span className="nst-soon">Soon</span> : null}
          </li>
        ))}
      </ul>
      {action}
      {note ? <p className="nst-tier-note">{note}</p> : null}
    </Tag>
  )
}
